import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable, ErrorHandler } from '@angular/core';
import { IApiResponse, IFilterPaginationDto, IRestaurantDto } from '../models';
import {
  IKioskBannerDto,
  IKioskTableDto,
  ITableDto,
} from '../models/table.model';

@Injectable()
export class TableService extends ApiService {
  constructor(http: HttpClient, errorHandler: ErrorHandler) {
    super(http, errorHandler);
  }

  public getTableReservationList(id: number,
    model: IFilterPaginationDto
  ): Observable<ITableDto[]> {
    return this.post(`admin/reservation/list/${id}`, model);
  }

  public getKioskBannerList(
    model: IFilterPaginationDto
  ): Observable<IKioskBannerDto[]> {
    return this.post(`admin/kiosk/banner/list`, model);
  }

  public acceptTableReservation(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/reservation/accept/${id}`, null);
  }

  public rejectTableReservation(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/reservation/reject/${id}`, null);
  }

  public getKioskTableList(
    model: IFilterPaginationDto
  ): Observable<IKioskTableDto[]> {
    return this.post(`admin/table/list`, model);
  }

  public addKioskTable(
    model: IKioskTableDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/table`, model);
  }

  public changeKioskTableStatus(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/table/${id}`, null);
  }

  // public updateTableFeature(
  //   model: ITableFeatureDto
  // ): Observable<IApiResponse<boolean>> {
  //   return this.put(`admin/table/feature`, model);
  // }

  public changeKioskSlot(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/kiosk/slot/${id}`, null);
  }

  public changeKioskSync(id: number): Observable<IApiResponse<boolean>> {
    return this.put(`admin/kiosk/sync/${id}`, null);
  }

  public deleteKioskTable(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/table/${id}`);
  }

  public addKioskBanner(
    model: IKioskBannerDto
  ): Observable<IApiResponse<boolean>> {
    return this.post(`admin/kiosk/banner`, model);
  }

  public changeKioskBannerStatus(
    id: number
  ): Observable<IApiResponse<boolean>> {
    return this.put(`admin/kiosk/banner/${id}`, null);
  }

  public deleteKioskBanner(id: number): Observable<IApiResponse<boolean>> {
    return this.delete(`admin/kiosk/banner/${id}`);
  }
}
